import { toast } from "react-toastify";
import { executePost } from "../ServiceMethods";
import { SessionTimeout } from "../ErrorMessages";
import { removeUserCredentials } from "../LocalStorage";

export const VerifyUserMobile = async (mobile, cb) => {
  try {
    const mobileVerification = await executePost(
      "/validateChangeMobileOtp",
      mobile
    );
    const mobileVerificationData = mobileVerification.data
      ? mobileVerification.data
      : {};
    return mobileVerificationData;
  } catch (err) {
    if (err.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
